import { initSentry } from "@/lib/sentry";

// Imported first by main.tsx: the router wrapper only instruments when Sentry.init has already run.
initSentry();
